// src/Constants/Version.js
export const SOFTWARE_VERSION = "1.0a";